import { PluginKey } from '@atlaskit/editor-prosemirror/state';
export var tableViewModeSortPluginKey = new PluginKey('tableViewModeSortPlugin');